import { DatePicker } from 'antd'

const AntDatePicker = DatePicker

export default AntDatePicker
